const sectionLabel: React.CSSProperties = {
  fontSize: '0.5625rem',
  fontWeight: 700,
  color: '#6b7280',
  textTransform: 'uppercase',
  letterSpacing: '0.08em',
  marginTop: '0.375rem',
};

const row: React.CSSProperties = {
  display: 'flex',
  justifyContent: 'space-between',
  fontSize: '0.75rem',
  color: '#d1d5db',
  padding: '0.125rem 0',
};

const val: React.CSSProperties = {
  fontWeight: 700,
  fontFamily: 'ui-monospace, monospace',
  color: '#e5e7eb',
};

export default function MetricsCardMock() {
  return (
    <div className="platform-mock mock-sidebar">
      <div className="platform-mock-header"><span className="dot" /> Metrics</div>
      <div className="platform-mock-body" style={{ padding: '1rem 1.25rem' }}>
        <div style={sectionLabel}>Structure &amp; Edge</div>
        <div style={row}><span>Payoff</span><span style={val}>2.0x</span></div>
        <div style={row}><span>Profit Factor</span><span style={val}>1.52</span></div>

        <div style={sectionLabel}>Trade Characteristics</div>
        <div style={row}><span>Trades</span><span style={val}>62</span></div>
        <div style={row}><span>Win Rate</span><span style={val}>44%</span></div>

        <div style={sectionLabel}>Risk-Adjusted</div>
        <div style={row}><span>Sharpe (ann.)</span><span style={val}>1.49</span></div>
        <div style={row}><span>Expectancy</span><span style={val}>$124</span></div>

        <div style={{
          marginTop: '0.75rem',
          paddingTop: '0.5rem',
          borderTop: '1px solid rgba(255,255,255,0.06)',
          fontSize: '0.625rem',
          color: '#6b7280',
          fontStyle: 'italic',
        }}>
          Historical simulation results.
        </div>
        <div style={{ fontSize: '0.6875rem', color: '#d1d5db', marginTop: '0.125rem' }}>
          Historical return: <span style={{ color: '#22c55e', fontWeight: 700 }}>+77.0%</span>
        </div>
      </div>
      <div className="platform-mock-caption">
        The Metrics card: structure and edge first, total return last.
      </div>
    </div>
  );
}
